import axios from 'axios'
import store from '@/store'

export default function api() {
  /* staging */
  // let proxy = process.env.VUE_APP_PROXY_URL; // only uncomment this if testing localhost against live
  // let proxy = "";
  let apiVersion = process.env.VUE_APP_GEMNOTE_API_VERSION
  let apiLocation = process.env.VUE_APP_GEMNOTE_API_URL
  // let apiLocation = 'https://api-staging.gemnote.com/api/';

  /* production */
  // let proxy = "http://localhost:8081/"; // only uncomment this if testing localhost against live
  // let proxy = "";
  // let apiVersion = "v2";
  // let apiLocation = "https://api.gemnote.com/api/";

  /* localhost */
  // let proxy = "";
  // let apiVersion = "";
  // let apiLocation = "http://localhost:3005";

  let axiosInstance = axios.create({
    baseURL: `${apiLocation}${apiVersion}/`,
    timeout: 120000
    // withCredentials: true
  })

  axiosInstance.interceptors.request.use(config => {
    let headers = store.getters['auth/auth']
    config.headers['access-token'] = headers['access-token']
    config.headers['client'] = headers['client']
    config.headers['expiry'] = headers['expiry']
    config.headers['uid'] = headers['uid']
    config.headers['token-type'] = headers['token-type']

    // this is to set recipient token for public store
    if (window.$cookies.isKey('public-store-token')) {
      config.headers['recipient-token'] = window.$cookies.get(
        'public-store-token'
      )
    }

    if (headers) {
      // console.log(
      //   `${config.method.toUpperCase()} requests sent to ${config.baseURL}${
      //     config.url
      //   }`
      // )
      return config
    }
  })

  axiosInstance.interceptors.response.use(
    config => {
      let user = store.getters['profile/user']
      if (
        config.headers['current-uid'] &&
        Object.entries(user).length &&
        user.email !== config.headers['current-uid']
      ) {
        store.dispatch(
          'profile/getProfile',
          { reloadProfile: true },
          { root: true }
        )
      }
      return config
    },
    function(error) {
      if (
        error.response.status === 401 &&
        error.response.data.errors[0] ===
          'You need to sign in or sign up before continuing.'
      ) {
        store.dispatch('auth/closeCurrentSession')
        return Promise.reject(error)
      } else if (error.response.status === 401) {
        let user = store.getters['profile/user']
        if (Object.entries(user).length) {
          store.dispatch(
            'profile/getProfile',
            { reloadProfile: true },
            { root: true }
          )
        }
        return Promise.reject(error)
      } else {
        return Promise.reject(error)
      }
    }
  )

  return axiosInstance
}

function responseDataFunctionSelector(isTesting) {
  if (isTesting) {
    return function(responseObject) {
      return responseObject.data
    }
  } else {
    return function(responseObject) {
      return responseObject.data.data
    }
  }
}

// set to true if testing, false if not testing
export const getData = responseDataFunctionSelector(false)
export const getIncluded = responseObject => {
  return responseObject.data.included
}
